import { FC } from 'react'

const ArrowCircleDown: FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  fill,
  height,
  width,
  ...rest
}) => {
  return (
    <svg
      className={className}
      width={width || '24'}
      height={height || '24'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM13 12H16L12 16L8 12H11V8H13V12Z'
        fill={fill || '#1D1D1F'}
      />
    </svg>
  )
}

export default ArrowCircleDown
